import React from 'react';
import { useLocation } from 'react-router-dom';
import RovquestLogo from '../../assets/images/Rovquest_logo.svg';
import NavbarLink from './NavbarLink';
import Profile from './Profile';

import DashboardIcon from 'assets/icons/MenuBar/Dashboard_icon';
import AlcoholIcon from 'assets/icons/MenuBar/Alcohol_icon';
import AttendanceIcon from 'assets/icons/MenuBar/Attendance_icon';
import DriverIcon from 'assets/icons/MenuBar/Driver_icon';
import VehicleIcon from 'assets/icons/MenuBar/Vehicle_icon';
import DeviceIcon from 'assets/icons/MenuBar/Device_icon';
import ClientIcon from 'assets/icons/MenuBar/Client_icon';
import { useTranslation } from 'react-i18next';

import {
  BASE_PATH,
  ALCOHOL_PATH,
  ATTANDANCE_PATH,
  DRIVER_PATH,
  VEHICLE_PATH,
  DEVICE_PATH,
  CLIENT_PATH,
} from 'router/pathName';

const Navbar: React.FC = () => {
  const { t } = useTranslation('layout');
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <div className="w-[20%] bg-primary/300 h-screen flex flex-col">
      <a href="/" className="p-4">
        <img src={RovquestLogo} alt="" />
      </a>
      <div className="flex-grow overflow-auto p-4">
        <NavbarLink
          icon={<DashboardIcon color="#30537E" />}
          label={t('dashboard')}
          link={BASE_PATH}
          isSelected={currentPath === BASE_PATH}
        />
        <NavbarLink
          icon={<AlcoholIcon color="#30537E" />}
          label={t('alcohol')}
          link={ALCOHOL_PATH}
          isSelected={currentPath === ALCOHOL_PATH}
        />
        <NavbarLink
          icon={<AttendanceIcon color="#30537E" />}
          label={t('attendance')}
          link={ATTANDANCE_PATH}
          isSelected={currentPath === ATTANDANCE_PATH}
        />
        <NavbarLink
          icon={<DriverIcon color="#30537E" />}
          label={t('driver')}
          link={DRIVER_PATH}
          isSelected={currentPath.startsWith(DRIVER_PATH)}
        />
        <NavbarLink
          icon={<VehicleIcon color="#30537E" />}
          label={t('vehicle')}
          link={VEHICLE_PATH}
          isSelected={currentPath.startsWith(VEHICLE_PATH)}
        />
        <NavbarLink
          icon={<DeviceIcon color="#30537E" />}
          label={t('device')}
          link={DEVICE_PATH}
          isSelected={currentPath === DEVICE_PATH}
        />
        <NavbarLink
          icon={<ClientIcon color="#30537E" />}
          label={t('client')}
          link={CLIENT_PATH}
          isSelected={currentPath.startsWith(CLIENT_PATH)}
        />
      </div>
      <div className="mt-auto p-4">
        <Profile />
      </div>
    </div>
  );
};

export default Navbar;